// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3L9Td","label":"Completed_label__1z1tQ"};